// <site-header>: shadow on scroll, mobile menu, and the search bar with predictive results.

import { $, debounce, escapeHtml, openOverlay, formatPrice } from '@theme/utils';

class SiteHeader extends HTMLElement {
  connectedCallback() {
    const header = $('.site-header', this) || this;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const menuButton = $('[data-open-menu]', this);
    menuButton?.addEventListener('click', () => {
      const menu = document.getElementById('MobileMenu');
      if (!menu) return;
      menuButton.setAttribute('aria-expanded', 'true');
      const close = openOverlay(menu, { onClose: () => menuButton.setAttribute('aria-expanded', 'false') });
      menu.querySelectorAll('[data-close-menu], a').forEach((el) => el.addEventListener('click', close, { once: true }));
    });

    const bar = $('[data-search-bar]', this);
    $('[data-toggle-search]', this)?.addEventListener('click', () => {
      bar.classList.toggle('is-open');
      if (bar.classList.contains('is-open')) $('input', bar).focus();
    });
    $('input', bar)?.addEventListener('input', debounce((event) => this.suggest(event.target.value), 250));
  }

  async suggest(query) {
    const out = $('[data-predictive]', this);
    if (!out) return;
    if (query.trim().length < 2) {
      out.innerHTML = '';
      return;
    }
    const url = `${window.theme.routes.predictiveSearch}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`;
    const data = await fetch(url).then((r) => r.json()).catch(() => null);
    // Add-ons (teddy, chocolates…) are extras, not gifts on their own.
    const products = (data?.resources?.results?.products || []).filter((p) => p.type !== 'Add-on').slice(0, 5);
    out.innerHTML = products.length
      ? products.map((p) => `<a href="${p.url}">${p.image ? `<img src="${p.image}&width=120" alt="" loading="lazy">` : '<span class="ph"></span>'}<span>${escapeHtml(p.title)}</span><span class="muted">${formatPrice(Math.round(Number(p.price) * 100))}</span></a>`).join('')
      : `<p class="muted">No gifts match "${escapeHtml(query)}". Try "birthday" or "anniversary".</p>`;
  }
}

customElements.define('site-header', SiteHeader);
